import cookie from 'js-cookie';
import assign from 'lodash/assign';
import { log } from 'utils/console';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import Logger from 'observability/Logger';

const LOG = new Logger('didymus');
const PATH = 'tuning-fork';
const COOKIE_NAME = 'tuningfork';
const DEFAULT_OPTIONS = {
    [COOKIE_NAME]: !!cookie.get(COOKIE_NAME),
    didymus: `Didymus: I have sworn with my life's blood,
              none shall pass this way without *my* permission!`,
};

const bootstrap = getBootstrap();

/**
 * @param {string} value
 * @param {string} key
 */
const throwIfUndefined = (value, key) => {
    if (value === undefined) {
        throw new Error(`Tuning fork error: no ${key}`);
    }
};

export default class Didymus {
    constructor(options = {}) {
        this.options = assign({}, DEFAULT_OPTIONS, options);
        this.auth = this.options[COOKIE_NAME] || false;
        this.redirect = bootstrap.get('tuningFork.previewUrl');

        throwIfUndefined(this.redirect, 'previewUrl');

        this.log(this.options.didymus);
        this.log('cookie', `${COOKIE_NAME}=${cookie.get(COOKIE_NAME)}`, this.redirect);

        // when logged in, we redirect to the view of the logged-in menu
        if (this.auth === 1) {
            this.log('REDIRECT', 'Didymus', this.redirect);
            document.location = this.redirect;
        }
    }

    log(...args) {
        log('tuning-fork-redirect', ...args);
    }

    //
    // Set / Get Methods
    //

    get redirect() {
        return this._redirect;
    }

    set redirect(domain) {
        const splashUrl = `${domain}`;
        const splashDomain = bootstrap.get('tuningFork.splashDomain');
        throwIfUndefined(splashDomain, 'splashDomain');

        this._redirect = `${splashDomain}/${PATH}/${splashUrl}`;
        return this._redirect;
    }

    get auth() {
        return this._auth;
    }

    set auth(auth) {
        this._auth = auth * 1;
        return this._auth;
    }

    //
    // Instance Methods
    //

    injectStyles() {
        if (typeof Promise === 'undefined') {
            LOG.warn('didymus.injectStyles - Promise is undefined');
            return { then: () => {} };
        }
        return new Promise((resolve, reject) => {
            this.log('Inject Styles');
            const redirectCss = bootstrap.get('tuningFork.redirectCss');
            throwIfUndefined(redirectCss, 'redirectCss');
            if (redirectCss.indexOf(document.location.origin) === 0) {
                const el = document.createElement('link');
                el.rel = 'stylesheet';
                el.media = 'all';
                el.href = redirectCss;
                el.onload = () => resolve();
                el.onerror = () => reject();
                const script = document.getElementsByTagName('script')[0];
                script.parentNode.insertBefore(el, script);
            }
            resolve();
        });
    }

    //
    // Static Methods
    //

    static verify(...args) {
        return new this(...args);
    }
}
